@if (toast$ | async; as toast) {
  <div class="aa-confirm-bar aa-toast" [style.border-color]="colorFor(toast.kind)">
    <svg class="icon" [style.color]="colorFor(toast.kind)"><use [attr.href]="iconFor(toast.kind)"></use></svg>
    <span>{{ toast.message }}</span>
    <button class="aa-btn aa-btn-ghost" style="padding:6px 12px; font-size:12px;" (click)="dismiss()">Close</button>
  </div>
}
